import * as React from 'react';
import { Provider } from 'jotai';
import { Navigate } from 'react-router-dom';
import AIRoadmap from '@components/ai-roadmap';
import { buildDashboardStore } from '@src/atoms/utils';
import usePageTitle from '@src/hooks/usePageTitle';
import { FeatureToggle } from '@components/common';
import featureNames from '@utils/featureToggle/constants';
import { homePagePath } from '@src/routers/utils';
import { Wrapper } from './styled';

const defaultStore = buildDashboardStore();

const AIRoadmapPage = (props) => {
  const { store = defaultStore } = props;

  usePageTitle({ text: 'AI Roadmap' });

  return (
    <FeatureToggle
      feature={featureNames.AI_ROADMAP}
      fallback={<Navigate to={homePagePath} replace />}
      checkRole
    >
      <Provider store={store}>
        <Wrapper>
          <AIRoadmap />
        </Wrapper>
      </Provider>
    </FeatureToggle>
  );
};

export default AIRoadmapPage;
